import TempWFRuleWrapper from "./TempWFRuleWrapper";

export default TempWFRuleWrapper;



// WEBPACK FOOTER //
// ./src/components/Template/TempWorkFlow/TempWFRuleWrapper/index.js